import { Box, Burger, Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Link } from "@tanstack/react-router";

import { useAuthUserPermissions, useAuthUserProfile } from "@/api/resources/auth/hooks";
import AppLogo from "@/components/AppLogo";
import NavbarDrawer from "@/components/Navbar/NavbarDrawer";
import NavbarUserMenu from "@/components/Navbar/NavbarUserMenu";
import TrialBanner from "@/components/Onboarding/TrialBanner";
import WorkspaceSelectorGlobal from "@/components/Workspace/WorkspaceSelectorGlobal";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { AppLayout, useAppLayout } from "@/hooks/useAppLayout";
import { useIsMobile } from "@/hooks/useIsMobile";
import Icon from "@/utils/icons";

const LayoutHeader = () => {
  const { isTablet } = useIsMobile();
  const { appLayout } = useAppLayout();
  const { data: profile } = useAuthUserProfile();
  const { data: permissions } = useAuthUserPermissions();

  const [opened, { close, toggle }] = useDisclosure();

  const isNavless = appLayout === AppLayout.Navless;

  return (
    <Group justify="space-between" bg="primary" wrap="nowrap">
      <Link to="/">
        <AppLogo />
      </Link>

      {profile && (
        <Group wrap="nowrap">
          <NavbarDrawer opened={opened} onClose={close} />

          <TrialBanner />

          {permissions?.globalAdmin && <Icon.SETTINGS color={SYSTEM_COLORS.warning} />}

          {isTablet && <Burger opened={opened} onClick={toggle} color={SYSTEM_COLORS.secondary} />}

          {!isTablet && !isNavless && (
            <Box w="19rem">
              <WorkspaceSelectorGlobal />
            </Box>
          )}

          <NavbarUserMenu />
        </Group>
      )}
    </Group>
  );
};

export default LayoutHeader;
